import React from 'react';
import Swal from 'sweetalert2';
import { generateAiAnalysisApi } from '../../services/api';

const PendingAiAnalysisCard = ({ selectedApp, roleApplicationId }) => {
    const hasVideo = !!(selectedApp.c_videoUrl || selectedApp.videoUrl);

    const handleGenerateAi = async () => {
        try {
            Swal.fire({
                title: 'Analyzing with Gemini AI...',
                text: 'Please wait...',
                didOpen: () => Swal.showLoading()
            });
            const response = await generateAiAnalysisApi(roleApplicationId);
            if (response.data?.success || response.success) {
                Swal.fire({ icon: 'success', title: 'AI Report Generated!', text: 'Reloading page...' });
                window.location.reload();
            } else {
                Swal.fire({ icon: 'error', title: 'Failed', text: response.data?.message || 'Could not generate AI report' });
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Something went wrong' });
        }
    };

    return (
        <div className="text-center py-5 card-dark p-5 rounded bg-dark border border-secondary text-white">
            <h5 className="text-warning">⏳ AI Audition Analysis Pending</h5>
            <p className="text-muted small mt-2">
                {hasVideo ? "Click below to generate AI analysis report now." : "Candidate has not uploaded an audition video yet."}
            </p>
            {hasVideo && (
                <button className="btn btn-danger btn-sm mt-3 fw-bold" onClick={handleGenerateAi}>
                    ⚡ Generate AI Analysis Now
                </button>
            )}
        </div>
    );
};

export default PendingAiAnalysisCard;
